import Vue from "vue"
import Router from "vue-router"

import SigninPage from "@/pages/Signin"

import store from "@/store"
import { setAuthHeader } from "@/services/api"
import { fetchLocalAuthInfo } from "@/store/modules/auth/providers/localStorage"

Vue.use(Router)

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "dash",
      component: () => import(/* webpackChunkName: "home" */ "./pages/Dash")
    },
    {
      path: "/signin",
      name: "signin",
      meta: { isPublic: true },
      component: SigninPage
    },
    {
      path: "/hours/import",
      name: "hourimport",
      component: () =>
        import(/* webpackChunkName: "hourimport" */ "./pages/HourImport")
    },
    {
      path: "/invoicing",
      name: "invoicing",
      component: () =>
        import(/* webpackCunkName: "invoicing" */ "./pages/Invoicing")
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.isPublic) {
    next()
  } else {
    if (store.getters.getAccessToken) {
      next()
    } else {
      const auth = fetchLocalAuthInfo()
      if (auth) {
        // we have a token from localstorage.
        // need to check its validity against the api
        // and either continue if valid
        // or redirect to login
        // maybe.. need to rethink in context of data fetching
        // and refresh flows
        setAuthHeader(auth.accessToken)
        store.commit("setAuthInfo", auth)
        next()
      } else {
        router.replace(`/signin?redirect=${to.path}`)
      }
    }
  }
})

export default router
